import { FC } from 'react';

import { PassStatusStubPage } from 'Pages/PassStatusStubPage';

export const PassStatusStubScreen: FC = () => {
  return <PassStatusStubPage />;
};
